<template>
  <div class="page-left">
    <div class="title">{{$t('Layout-SiderNavGuild0') || '公会管理'}}</div>
    <!-- <router-link v-if="checkPermission('guild-home') " :class="{'current' : 'guild-home' == current}" :to="{name:'guild-home'}" class="home">{{$t('Layout-SiderNavGuild1') || '公会概况'}}</router-link>
    <router-link v-if="checkPermission('guild-tasks')" :class="{'current' : taskSettingCheck}" :to="{name:'guild-tasks'}" class="tasks">{{$t('Layout-SiderNavGuild2') || '公会任务管理'}}</router-link>
    <router-link v-if="checkPermission('guild-users') " :class="{'current' : 'guild-users' == current}" :to="{name:'guild-users'}" class="users">{{$t('Layout-SiderNavGuild3') || '公会成员管理'}}</router-link>
    <router-link :class="{'current' : 'guild-statistics' == current}" :to="{name:'guild-statistics'}" class="statistics">{{$t('guild-statistics')||'统计分析'}}</router-link>
    <router-link v-if="checkPermission('guild-tag')" :class="{'current' : current.indexOf('tag') > -1}" :to="{name:'guild-tag'}" class="tag">{{$t('Layout-SiderNavGuild4') || '业务标签认证'}}</router-link>
    <router-link v-if="checkPermission('guild-setting')" :class="{'current' : 'guild-setting' == current}" :to="{name:'guild-setting'}" class="setting">{{$t('guild-Setting-Home2') || '公会设置'}}</router-link> -->
    <Menu class='subsciribe-scroll' style ="width:200px" :accordion='true'>
      <div v-for ="(item,index) in filterSideMenuList" :key="index">
         <Submenu :name="item.name" :key="item.name" v-if="item.children && item.children.length > 0">
          <template slot="title">
            <a :class="{'current' : item.name == current,[item.class]:true}">{{item.title}}</a>
          </template>
           <MenuItem :name="itm.name" v-for="(itm,inx) in item.children" :key ="inx">
             <router-link :class="{'current' : itm.name == current}" :to="{name:itm.name}" style ="padding-left:0px">{{itm.title}}</router-link>
           </MenuItem>
        </Submenu>
         <MenuItem :name="item.name" :key="item.name" v-else>
            <router-link :class="{'current' : item.name == current,[item.class]:true}" :to="{name:item.name}">{{item.title}}</router-link>
         </MenuItem>
      </div>
    </Menu>
  </div>
</template>

<script>
import {
  checkPermission
} from 'assets/scripts/permissions';
import {getAuthForm} from '../guild/UsersManage/user.js'
export default {
  data () {
    return {
      authInfoForm: null,
      current: '',
      taskSettingCheck: false,
      sideMenu:[
        {name:'guild-home',children:[],class:'home',title:window.i18n.t('Layout-SiderNavGuild1')},
        {name:'guild-tasks',children:[],class:'tasks',title:window.i18n.t('Layout-SiderNavGuild2')},
        {name:'guild-users',children:[],class:'users',title:window.i18n.t('Layout-SiderNavGuild3')},
        {name:'guild-statistics',
          children:[
              {name:'guild-statistics-item3',title:window.i18n.t('guild-statistics-item3')},
              {name:'guild-statistics-item1',title:window.i18n.t('guild-statistics-item1')},
              {name:'guild-statistics-item2',title:window.i18n.t('guild-statistics-item2')},
          ],
          class:'statistics',title:window.i18n.t('guild-statistics')},
        {name:'guild-tag',children:[],class:'tag',title:window.i18n.t('Layout-SiderNavGuild4')},
        {name:'guild-setting',children:[],class:'setting',title:window.i18n.t('guild-Setting-Home2')},
      ],
    }
  },
  props: ['isTripartite'],
  computed: {
  },

  watch: {
    $route (to, from) {
      this.current = to.name;
      if (this.current.indexOf('tasks') > -1) {
        this.taskSettingCheck = true;
      } else {
        this.taskSettingCheck = false;
      }
    }
  },
 

  methods: {
    // 校验权限
    checkPermission: function (buttonId) {
       // 三方用户不能看到公会成员管理
      if (buttonId === 'guild-users') {
        // 如果已获取到 authInfoForm，按 userOrgType 做拦截
        if (this.authInfoForm && Number(this.authInfoForm.userOrgType) === 3) {
          return false;
        }
        // 如果 authInfoForm 还未就绪，fallback 到通用权限校验（避免把 Promise 对象当作 authInfo）
      }
      return checkPermission(buttonId);
    },
  },
    created() {
    const res = getAuthForm();
    if (res && typeof res.then === 'function') {
      res.then(data => {
        this.authInfoForm = data || null;
      }).catch(() => {
        this.authInfoForm = null;
      });
    } else {
      this.authInfoForm = res || null;
    }
  },
  computed:{
    filterSideMenuList(){
      return this.sideMenu.filter(item =>this.checkPermission(item.name));
    }
  },
  mounted () {
    this.current = this.$route.name;
    if (this.current.indexOf('tasks') > -1) {
      this.taskSettingCheck = true;
    } else {
      this.taskSettingCheck = false;
    }
  }
};
</script>

<style lang="less" scoped>
  @import "../../assets/theme/themeBlue.less";
  .page-left {
    line-height: 40px;
    width: 200px;
    text-align: left;
    background: #fff;
     .subsciribe-scroll {
       .ivu-menu-submenu  /deep/ .ivu-menu-submenu-title{
        padding:0 0;
      }
      &::-webkit-scrollbar {
        display: none;
      }
    }
    /deep/ .ivu-menu-vertical .ivu-menu-item, .ivu-menu-vertical .ivu-menu-submenu-title {
      padding:0 0;
      border-bottom: 1px dashed #DEDEDE;
    }
    a,.title{
      display:flex;
      flex-direction: column;
      border-bottom: 1px dashed #DEDEDE;
      line-height: 52px;
      color: #494949;
      padding-left: 50px;
      font-size: 14px;
      position: relative;
    }
    .title{
      border:0;
      font-size: 16px;
      font-weight: bold;
      color:#18CA6C;
      background: url(../../assets/images/guild/bg.png) no-repeat 0 0;
      width: 200px;
    }
    a:last-child{
      border:0;
    }
    a.current,a:hover{
      color:#18CA6C
    }
    a::before{
      position: absolute;
      width: 16px;
      height: 16px;
      display: block;
      content: '';
      left:25px;
      top: 18px;
    }
    a.home::before{
      background: url(../../assets/images/guild/home.png) no-repeat center center;
    }
    a.tasks::before{
      background: url(../../assets/images/guild/task.png) no-repeat center center;
    }
    a.users::before{
      background: url(../../assets/images/guild/user.png) no-repeat center center;
    }
    a.statistics::before{
      background: url(../../assets/images/guild/statistics.png) no-repeat center center;
    }
    a.setting::before{
      background: url(../../assets/images/guild/setting.png) no-repeat center center;
    }
    a.tag::before{
      background: url(../../assets/images/guild/tag.png) no-repeat center center;
    }
    a.home.current::before,a.home:hover::before{
      background: url(../../assets/images/guild/home-i.png) no-repeat center center;
    }
    a.tasks.current::before,a.tasks:hover::before{
      background: url(../../assets/images/guild/task-i.png) no-repeat center center;
    }
    a.users.current::before,a.users:hover::before{
      background: url(../../assets/images/guild/user-i.png) no-repeat center center;
    }
    a.statistics.current::before,a.statistics:hover::before{
      background: url(../../assets/images/guild/statistics-i.png) no-repeat center center;
    }
    a.setting.current::before,a.setting:hover::before{
      background: url(../../assets/images/guild/setting-i.png) no-repeat center center;
    }
    a.tag.current::before,a.tag:hover::before{
      background: url(../../assets/images/guild/tag-i.png) no-repeat center center;
    }
  }
</style>
